export function downloadFile(blob: any, type: string, name: string): void {
    const file = new Blob([blob], { type });
    const link = document.createElement("a")
    const url = window.URL.createObjectURL(file)
    document.body.appendChild(link)
    link.href = url
    link.download = name
    link.click()
    window.URL.revokeObjectURL(url)
    link.remove()
}
